module.exports = __webpack_public_path__ + "img/5.51b2f33b.png";